import { defineStore } from 'pinia'
import { useSessionStore } from './session'

const pageMap = {
  Star: '名人堂',
  Store: '商城',
  Apply: '报名',
  Schedule: '赛程',
  Live: '直播',
  Teams: '战队',
  Quiz: '竞猜',
  DetailClan: '战队详情',
  DetailMembers: '队员详情'
}

const createModalStatus = () => ({
  id: '',
  params: {}
})

const DEFAULT_PROMPT_DURATION = 1500

const createPromptStatus = () => ({
  message: '',
  ts: 0,
  duration: DEFAULT_PROMPT_DURATION
})

const createState = () => ({
  scale: 1,
  navStatus: {},
  fullScreen: false,
  clientSize: {},
  subPage: '',
  modalStatus: createModalStatus(),
  promptStatus: createPromptStatus()
})

export const useUiStore = defineStore('ui', {
  state: () => createState(),
  actions: {
    openModal(payload) {
      this.modalStatus = payload || createModalStatus()
    },
    closeModal() {
      this.modalStatus = createModalStatus()
    },
    // 全局 toast: 任意位置调用, 由 App 层挂载的 UiPrompt watch 触发展示
    // ts 每次刷新, 连续调用同一条消息也能触发; duration 可覆盖默认 1500ms
    showPrompt(message, duration = DEFAULT_PROMPT_DURATION) {
      this.promptStatus = { message, ts: Date.now(), duration }
    },
    setCurrentPage(page = '', options = {}) {
      const { track = true } = options
      if (page) {
        this.subPage = page
      }

      if (track) {
        this.syncPageAnalytics()
      }
    },
    syncPageAnalytics() {
      if (typeof tapdb === 'undefined') return

      const sessionStore = useSessionStore()
      tapdb.setPagePropertyEvent({
        '#tag': 'sausageMatch',
        '#page': this.subPage,
        '#user_id': sessionStore.uid
      })
      tapdb.trackEvent('切换页签', {
        '#name': pageMap[this.subPage] || this.subPage
      })
    }
  }
})
